import "@fortawesome/fontawesome-free/css/all.min.css";
import { useState } from "react";

function Webwasa() {
  const [activeTab, setActiveTab] = useState("methodology");

  return (
    <div>
      {/* -- Banner sec ---- */}
      <div className="page-banner-area">
        <h2>Services</h2>
        <div className="breadcrumbs-services">
          <ul>
            <li>
              <a href="/">Home</a>
            </li>
            <li> Red Team Assessment</li>
          </ul>
        </div>
      </div>
      {/* -- Banner sec ---- */}

      {/* ---- About service section ----- */}
      <div className="about-services-wrap">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              {/* headings */}
              <div className="heading-in mb-5">
                <h1>Red Team Assessment</h1>
                <p>
                  <b className="sub-heading">Introduction</b>
                  <br />
                  A Red Team Assessment is a full-scale, simulated cyberattack
                  designed to test your organization’s detection, response, and
                  defense capabilities against real-world threats. Unlike
                  traditional penetration testing, which focuses on finding
                  technical vulnerabilities, Red Team exercises evaluate your
                  people, processes, and technology under realistic attack
                  scenarios. The objective is not only to uncover weaknesses
                  but also to test how effectively your security team can
                  identify, contain, and respond to a sophisticated adversary.
                </p>
              </div>

              {/* Why It Matters */}
              <div className="service-card-heading">
                <h1>Why It Matters</h1>
              </div>
              <div className="services-cards-wp">
                {[
                  {
                    icon: "fa-arrows-down-to-people",
                    title: "Realistic Threat Simulation",
                    desc: "Cybercriminals don’t follow checklists — they use creativity, persistence, and stealth. A Red Team exercise replicates that mindset.",
                  },
                  {
                    icon: "fa-database",
                    title: "Beyond Technical Flaws",
                    desc: "It exposes gaps in monitoring, response, and human behavior (like phishing susceptibility).",
                  },
                  {
                    icon: "fa-shield-halved",
                    title: "Response Readiness",
                    desc: "Tests how quickly and effectively your blue team (defenders) can detect and stop ongoing attacks.",
                  },
                  {
                    icon: "fa-table",
                    title: "Board-Level Assurance",
                    desc: "Provides executives with a realistic view of the organization’s security posture and resilience.",
                  },
                  {
                    icon: "fa-business-time",
                    title: "Continuous Improvement",
                    desc: "Identifies weaknesses in incident response playbooks, SOC monitoring, and crisis management.",
                  },
                ].map((item, i) => (
                  <div className="service-box" key={i}>
                    <div className="service-icon">
                      <i className={`fa-solid ${item.icon}`}></i>
                    </div>
                    <div className="service-card-content">
                      <h3>{item.title}</h3>
                      <p>{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>

              {/* Tabs */}
              <div className="tab-pill-sec-main">
                <div className="tab-inner-contain">
                  <ul className="nav nav-pills">
                    {[
                      { id: "methodology", label: "Methodology" },
                      { id: "keybenefits", label: "Key Benefits" },
                      { id: "deliverables", label: "Deliverables" },
                    ].map((tab) => (
                      <li className="nav-item" key={tab.id}>
                        <button
                          className={`nav-link${activeTab === tab.id ? " active" : ""}`}
                          onClick={() => setActiveTab(tab.id)}
                        >
                          {tab.label}
                        </button>
                      </li>
                    ))}
                  </ul>

                  <div className="tab-content">
                    {/* Methodology */}
                    <div
                      className={`tab-pane fade${activeTab === "methodology" ? " show active" : ""}`}
                      role="tabpanel"
                    >
                      <p>
                        Our Red Team Assessments follow a
                        threat-intelligence-driven approach aligned with
                        frameworks such as MITRE ATT&CK and TIBER-EU. Typical
                        phases include:
                      </p>
                      <ul>
                        <li><b>Reconnaissance :-</b> Collect intelligence on your organization, employees, infrastructure, and exposed assets.</li>
                        <li><b>Initial Access :-</b> Use tactics like spear-phishing, credential stuffing, or exploitation of exposed services.</li>
                        <li><b>Privilege Escalation & Persistence :-</b> Attempt lateral movement and gain deeper access within networks.</li>
                        <li><b>Data Exfiltration & Objectives :-</b> Simulate theft of sensitive data, financial fraud, or system disruption.</li>
                        <li><b>Detection & Response Evaluation :-</b> Measure how quickly your security team identifies and reacts.</li>
                        <li><b>Debrief & Reporting :-</b> Provide a clear, actionable breakdown of findings and response effectiveness.</li>
                      </ul>
                    </div>

                    {/* Key Benefits */}
                    <div
                      className={`tab-pane fade${activeTab === "keybenefits" ? " show active" : ""}`}
                      role="tabpanel"
                    >
                      <ul>
                        <li>Real-world assessment of your security readiness against advanced attackers.</li>
                        <li>Identification of gaps in monitoring, detection, and incident response.</li>
                        <li>Improved SOC maturity and incident response playbooks.</li>
                        <li>Increased confidence for executives, clients, and regulators.</li>
                        <li>Prioritized roadmap for strengthening defensive capabilities.</li>
                      </ul>
                    </div>

                    {/* Deliverables */}
                    <div
                      className={`tab-pane fade${activeTab === "deliverables" ? " show active" : ""}`}
                      role="tabpanel"
                    >
                      <p>You will receive:</p>
                      <ul>
                        <li><b>Comprehensive Red Team Report :-</b> Detailed findings, attack paths, and impact analysis.</li>
                        <li><b>Remediation & Hardening Guidance :-</b> Specific actions to strengthen defenses across people, process, and technology.</li>
                        <li><b>Detection & Response Metrics :-</b> Insights on how your team performed during the exercise.</li>
                        <li><b>Executive Summary :-</b> Non-technical overview for leadership and board members.</li>
                        <li><b>Debrief Workshop :-</b> Walkthrough of attack scenarios, lessons learned, and resilience improvements.</li>
                        <li><b>Follow-up Validation (Optional) :-</b> Retesting to measure improvements after remediation.</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              {/* Our Approach */}
              <div className="our-approach-sec-main">
                <div className="container">
                  <h3>Our Approach</h3>
                  <p>
                    We go beyond testing systems — we test your organization’s
                    cyber resilience as a whole. Here’s what makes us the best
                    partner for Red Teaming:
                  </p>
                  <ul>
                    <li><b>Adversary Emulation :-</b> We simulate nation-state, cybercriminal, or insider threat scenarios tailored to your industry.</li>
                    <li><b>Holistic Testing :-</b> Our assessments include technical exploitation, social engineering, and physical security testing.</li>
                    <li><b>Stealth & Realism :-</b> We use advanced, low-and-slow tactics that mimic real adversaries — not just automated tools.</li>
                    <li><b>Blue Team Collaboration :-</b> Post-engagement, we work closely with your defenders to strengthen detection and response playbooks.</li>
                    <li><b>Industry Expertise :-</b> Extensive experience across finance, healthcare, government, and critical infrastructure.</li>
                    <li><b>Actionable Outcomes :-</b> We help you build resilience against advanced persistent threats (APTs).</li>
                  </ul>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      {/* ---- About service section ----- */}
    </div>
  );
}

export default Webwasa;
